import { EmployeeManAltIcon, StopCircle04Icon } from '@forwardflow/icons'
import { useDnDStageMappingContext } from '../../hooks/useDnDStageMappingContext'
import { DnDStageGroupDropZone } from '../DnDStageGroupDropZone'

interface StoppedStagesTabProps {
   onRemoveStage?: (stageId: string) => void
   onRemoveTag?: (tagId: string) => void
}

export const StoppedStagesTab = ({
   onRemoveStage,
   onRemoveTag,
}: StoppedStagesTabProps) => {
   const { getStagesAndTagsByIdentifier } = useDnDStageMappingContext()
   const { stages: doNotContactStages, tags: doNotContactTags } =
      getStagesAndTagsByIdentifier('ff-do-not-contact')

   const { stages: hasAgentStages, tags: hasAgentTags } =
      getStagesAndTagsByIdentifier('ff-has-agent')

   const { stages: otherStopStages, tags: otherStopTags } =
      getStagesAndTagsByIdentifier('ff-other-stop')

   return (
      <div className="space-y-5">
         <DnDStageGroupDropZone
            isMandatory={true}
            stages={doNotContactStages}
            tags={doNotContactTags}
            icon={<StopCircle04Icon width={24} height={24} />}
            title="Do Not Contact"
            id="ff-do-not-contact"
            key="ff-do-not-contact"
            description="The lead is not ready now, but is still viable. They have a future timeline or need long-term follow-up. Often 3-12+ months out."
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />

         <DnDStageGroupDropZone
            stages={hasAgentStages}
            tags={hasAgentTags}
            icon={<EmployeeManAltIcon width={24} height={24} />}
            title="Has Another Agent"
            id="ff-has-agent"
            key="ff-has-agent"
            description="The lead is not ready now, but is still viable. They have a future timeline or need long-term follow-up. Often 3-12+ months out."
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />

         <DnDStageGroupDropZone
            stages={otherStopStages}
            tags={otherStopTags}
            icon={<StopCircle04Icon width={24} height={24} />}
            title="All other Stop Criterias"
            id="ff-other-stop"
            key="ff-other-stop"
            description="Stages and Tags where FF stops contacting the lead"
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />
      </div>
   )
}
